import {
  Box,
  Flex,
  Icon,
  RangeSlider,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  RangeSliderTrack,
  Text,
} from '@chakra-ui/react';
import { FaSun, FaMoon } from 'react-icons/fa';
import { useMemo, useState } from 'react';

function displayTime(number) {
  if (number < 0 || number > 24) {
    return 'Invalid input: number must be between 0 and 24';
  } else if (number === 0) {
    return '12 AM';
  } else if (number < 12) {
    return number + ' AM';
  } else if (number === 12) {
    return '12 PM';
  } else {
    return number - 12 + ' PM';
  }
}

export default function CallRangePicker({
  start = 0,
  end = 24,
  onChangeEnd,
}) {
  const defaultRange = useMemo(() => [start, end], [start, end]);
  const [range, setRange] = useState(defaultRange);
  return (
    <Box>
      <Text fontSize="xs" color="gray.600" fontWeight="medium" mb={2}>
        Between
      </Text>
      <Box flex="1" py={1}>
        <RangeSlider
          aria-label={['start-time', 'end-time']}
          defaultValue={defaultRange}
          min={0}
          max={24}
          step={1}
          onChangeEnd={onChangeEnd}
          onChange={setRange}
          minStepsBetweenThumbs={2}
          colorScheme="brand"
          size="lg"
        >
          <RangeSliderTrack bg="gray.200">
            <RangeSliderFilledTrack bg="brand.500" borderRadius="full" />
          </RangeSliderTrack>
          <RangeSliderThumb
            index={0}
            boxSize={5}
            borderWidth="2px"
            borderColor="brand.500"
            _focus={{ boxShadow: '0 0 0 2px var(--chakra-colors-brand-100)' }}
          />
          <RangeSliderThumb
            index={1}
            boxSize={5}
            borderWidth="2px"
            borderColor="brand.500"
            _focus={{ boxShadow: '0 0 0 2px var(--chakra-colors-brand-100)' }}
          />
        </RangeSlider>
      </Box>
      <Flex justify="space-between" align="center" mt={1} gap={2}>
        <Flex align="center" gap={1} fontSize="sm" color="brand.700" fontWeight="semibold">
          <Icon as={FaSun} boxSize={4} />
          <Text>{displayTime(range[0])}</Text>
        </Flex>
        <Flex align="center" gap={1} fontSize="sm" color="brand.700" fontWeight="semibold">
          <Icon as={FaMoon} boxSize={4} />
          <Text>{displayTime(range[1])}</Text>
        </Flex>
      </Flex>
    </Box>
  );
}

